import { Typography, makeStyles } from '@material-ui/core';
import { formatDistanceToNow, differenceInMinutes } from 'date-fns';
import { warning } from 'src/data/colors';

const BOLD_THRESHOLD = 5;
const WARNING_THRESHOLD = 15;

const useStyles = makeStyles(() => ({
  subtitle2: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: '0.4px',
  },
  warn: {
    color: `${warning}`,
  },
  bold: {
    fontWeight: 600,
  },
}));

const isBiggerThanThreshold = (lastFetchTime: Date | undefined, threshold: number) =>
  lastFetchTime === undefined || differenceInMinutes(new Date(), lastFetchTime) >= threshold;

interface LastUpdatedProps {
  lastFetchTime?: Date;
}

const LastUpdated = ({ lastFetchTime }: LastUpdatedProps) => {
  const classes = useStyles();
  const warn = isBiggerThanThreshold(lastFetchTime, WARNING_THRESHOLD) ? classes.warn : '';
  const bold = isBiggerThanThreshold(lastFetchTime, BOLD_THRESHOLD) ? classes.bold : '';

  return (
    <Typography variant="body2" className={`${classes.subtitle2} ${bold} ${warn}`}>
      Last updated:{' '}
      {lastFetchTime
        ? formatDistanceToNow(lastFetchTime, { addSuffix: true })
        : 'More than 4 hours ago'}
    </Typography>
  );
};

export default LastUpdated;
